export const enumPermisosTrx = Object.freeze({
  parametros_autorizadores: 51,
  tipos_transacciones: 31,
  planes_comision: 18,
  asignacion_comision: 19,
  convenios: 20,
  autorizadores: 21,
  configuracion_comercios: 21,
  contratos_comisiones: 21,
  tipo_nivel_comercio: 21,
  comercios: 21,
  gestion_permisos_comercios_broker: 17001,
  gestion_permisos_broker: 17000,
  mensajes_publicitarios: 21,
  grupos_convenios: 20,
  categorizacion: 191,
  gestion_comercios: 210,
  gestion_historico_comercios: 211,
  grupos_comercios: 21,
  PARAMETRIZACION_CODIGOS_BARRAS_CONVENIOS: 20,
  DISTRIBUCION_TRANSACCIONES: 20,
  RECAUDO_GENERICO_ADMINISTRAR_CONVENIOS: 20,
  CATEGORIA_RECAUDO_GENERICO: 20,
  BLOQUEAR_CONVENIO_TODOS: 192,
  TERMINALES: 17002,
  HISTORICO_TERMINALES: 17003,
});
